import { createClient } from 'contentful';
import { GraphQLClient } from 'graphql-request';

const CONTENTFUL_SPACE_ID = 'hha8dh6xg6vg';
const CONTENTFUL_DELIVERY_API_ACCESS_TOKEN = 'Qd2foEqSKiutpqee0mlURZP2mniydYu-R5l21d-5nrY';
export const CONTENT_DELIVERY_ENDPOINT = `https://graphql.contentful.com/content/v1/spaces/${CONTENTFUL_SPACE_ID}/environments/master`;

export const cmsClient = createClient({
  accessToken: CONTENTFUL_DELIVERY_API_ACCESS_TOKEN,
  space: CONTENTFUL_SPACE_ID
});

export const graphQLClient = new GraphQLClient(CONTENT_DELIVERY_ENDPOINT, {
  headers: {
    Authorization: `Bearer ${CONTENTFUL_DELIVERY_API_ACCESS_TOKEN}`
  }
});

export const buildURL = (pageAssemblyReference) => {
  const getAllSlugs = (object, url) => {
    const newURL = url ? `${object.slug}/${url}` : object.slug || '';
    if (object.parent) {
      return getAllSlugs(object.parent, newURL);
    }
    return '/' + newURL;
  };
  return getAllSlugs(pageAssemblyReference);
};
